// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var $$String = require("rescript/lib/js/string.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.res.js");
var Belt_SetString = require("rescript/lib/js/belt_SetString.js");
var JsxRuntime = require("react/jsx-runtime");
var Http$ReactHooksTemplate = require("../common/http.res.js");
var Image$ReactHooksTemplate = require("../common/image.res.js");
var DragDrop$ReactHooksTemplate = require("../surveys/DragDrop.res.js");
var ToggleInput$ReactHooksTemplate = require("../common/ToggleInput.res.js");
var ConfirmDialog$ReactHooksTemplate = require("../common/ConfirmDialog.res.js");
var AlertComponent$ReactHooksTemplate = require("../common/AlertComponent.res.js");
var ImportEnrichmentRule$ReactHooksTemplate = require("./importEnrichmentRule.res.js");
var ImportEnrichmentCondition$ReactHooksTemplate = require("./ImportEnrichmentCondition.res.js");
var ImportEnrichmentRuleCodec$ReactHooksTemplate = require("./ImportEnrichmentRuleCodec.res.js");
var ImportEnrichmentRuleTypes$ReactHooksTemplate = require("./ImportEnrichmentRuleTypes.res.js");
var ImportEnrichmentActionForm$ReactHooksTemplate = require("./ImportEnrichmentActionForm.res.js");
var ImportEnrichmentRuleHelpers$ReactHooksTemplate = require("./ImportEnrichmentRuleHelpers.res.js");
var ImportEnrichmentFieldOptions$ReactHooksTemplate = require("./ImportEnrichmentFieldOptions.res.js");
var ImportEnrichmentConditionForm$ReactHooksTemplate = require("./ImportEnrichmentConditionForm.res.js");
var ImportEnrichmentConditionTest$ReactHooksTemplate = require("./ImportEnrichmentConditionTest.res.js");
var ImportEnrichmentRuleSimulator$ReactHooksTemplate = require("./ImportEnrichmentRuleSimulator.res.js");
var ImportEnrichmentRuleValidation$ReactHooksTemplate = require("./ImportEnrichmentRuleValidation.res.js");
var ImportEnrichmentSimulationInputs$ReactHooksTemplate = require("./ImportEnrichmentSimulationInputs.res.js");
var ImportEnrichmentSimulationFixture$ReactHooksTemplate = require("./ImportEnrichmentSimulationFixture.res.js");

var inputBase = "w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm transition duration-150 bg-white";

var selectBase = inputBase + " cursor-pointer";

var labelBase = "block text-sm font-medium text-gray-700 mb-1.5";

var hintClass = "text-xs text-gray-500 leading-snug mt-1.5";

var sectionWrap = "pl-5 border-l-4 rounded-r-lg scroll-mt-6";

var cardInner = "border border-gray-200 rounded-xl p-4 bg-white shadow-sm";

var ghostBtn = "px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors duration-200";

var primaryBtn = "px-6 py-2 text-sm font-medium text-white rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors duration-200";

function ImportEnrichmentRules(props) {
  var campaignId = props.campaignId;
  var match = React.useReducer(ImportEnrichmentRuleTypes$ReactHooksTemplate.reducer, ImportEnrichmentRuleTypes$ReactHooksTemplate.initialState);
  var dispatch = match[1];
  var state = match[0];
  var match$1 = React.useState(function (param) {
        return "Basics";
      });
  var setActiveFormStep = match$1[1];
  var activeFormStep = match$1[0];
  var match$2 = React.useState(function (param) {
        
      });
  var setPendingConfirm = match$2[1];
  var pendingConfirm = match$2[0];
  var match$3 = React.useState(function (param) {
        return false;
      });
  var setConfirming = match$3[1];
  var confirming = match$3[0];
  var scrollSpyPausedRef = React.useRef(false);
  var stateRef = React.useRef(state);
  var pendingConfirmRef = React.useRef(pendingConfirm);
  React.useEffect((function (param) {
          stateRef.current = state;
        }), [state]);
  React.useEffect((function (param) {
          pendingConfirmRef.current = pendingConfirm;
        }), [pendingConfirm]);
  React.useEffect((function (param) {
          ImportEnrichmentRuleHelpers$ReactHooksTemplate.fetchRules(dispatch, campaignId);
          ImportEnrichmentRuleHelpers$ReactHooksTemplate.fetchFieldOptions(dispatch, campaignId);
        }), []);
  React.useEffect((function (param) {
          if (state.formOpen) {
            Curry._1(setActiveFormStep, (function (param) {
                    return "Basics";
                  }));
          }
          
        }), [state.formOpen]);
  React.useEffect((function (param) {
          if (!state.formOpen) {
            return ;
          }
          var onSectionChange = function (sectionId) {
            if (!scrollSpyPausedRef.current) {
              return Curry._1(setActiveFormStep, (function (param) {
                            return ImportEnrichmentRuleTypes$ReactHooksTemplate.formStepFromSectionId(sectionId);
                          }));
            }
            
          };
          var cleanupRef = {
            contents: undefined
          };
          var timeoutId = setTimeout((function (param) {
                  cleanupRef.contents = ((onChange) => {
                  const root = document.getElementById('ier-form-scroll');
                  if (!root) return () => {};
                  const sectionIds = [
                    'ier-section-basics',
                    'ier-section-when',
                    'ier-section-then',
                    'ier-section-test',
                  ];
                  const ratioById = {};
                  const pickActive = () => {
                    let bestId = sectionIds[0];
                    let bestRatio = -1;
                    sectionIds.forEach((id) => {
                      const ratio = ratioById[id] || 0;
                      if (ratio > bestRatio) {
                        bestRatio = ratio;
                        bestId = id;
                      }
                    });
                    if (bestRatio > 0) onChange(bestId);
                  };
                  const observer = new IntersectionObserver(
                    (entries) => {
                      entries.forEach((entry) => {
                        ratioById[entry.target.id] = entry.intersectionRatio;
                      });
                      pickActive();
                    },
                    {
                      root,
                      rootMargin: '-12% 0px -55% 0px',
                      threshold: [0, 0.1, 0.25, 0.5, 0.75, 1],
                    },
                  );
                  sectionIds.forEach((id) => {
                    const el = document.getElementById(id);
                    if (el) observer.observe(el);
                  });
                  const onScroll = () => pickActive();
                  root.addEventListener('scroll', onScroll, { passive: true });
                  pickActive();
                  return () => {
                    observer.disconnect();
                    root.removeEventListener('scroll', onScroll);
                  };
                })(onSectionChange);
                }), 50);
          return (function (param) {
                    clearTimeout(timeoutId);
                    var cleanup = cleanupRef.contents;
                    if (cleanup !== undefined) {
                      return Curry._1(cleanup, undefined);
                    }
                    
                  });
        }), [state.formOpen]);
  var simulationPathKey = Belt_List.toArray(Belt_List.sort(Belt_SetString.toList(ImportEnrichmentSimulationInputs$ReactHooksTemplate.collectPaths(state.conditions, state.actions)), $$String.compare)).join("|");
  React.useEffect((function (param) {
          if (state.formOpen) {
            var pathList = Belt_List.sort(Belt_SetString.toList(ImportEnrichmentSimulationInputs$ReactHooksTemplate.collectPaths(state.conditions, state.actions)), $$String.compare);
            var merged = ImportEnrichmentSimulationFixture$ReactHooksTemplate.mergeInputsForPaths(pathList, state.simulationInputs);
            Curry._1(dispatch, {
                  TAG: "SetSimulationInputs",
                  _0: merged
                });
          }
          
        }), [
        state.formOpen,
        simulationPathKey
      ]);
  var openCreate = function (param) {
    var empty = ImportEnrichmentRule$ReactHooksTemplate.empty();
    var actions_0 = ImportEnrichmentRuleTypes$ReactHooksTemplate.emptyAction();
    var actions = {
      hd: actions_0,
      tl: /* [] */0
    };
    Curry._1(dispatch, {
          TAG: "SetSelected",
          _0: empty
        });
    Curry._1(dispatch, {
          TAG: "SetConditionMode",
          _0: "All"
        });
    Curry._1(dispatch, {
          TAG: "SetConditions",
          _0: /* [] */0
        });
    Curry._1(dispatch, {
          TAG: "SetActions",
          _0: actions
        });
    Curry._1(dispatch, {
          TAG: "SetPipelineFeed",
          _0: true
        });
    Curry._1(dispatch, {
          TAG: "SetPipelineTrigger",
          _0: true
        });
    Curry._1(dispatch, {
          TAG: "SetSimulationInputs",
          _0: ImportEnrichmentSimulationFixture$ReactHooksTemplate.defaultInputValues()
        });
    Curry._1(dispatch, {
          TAG: "SetSimulationResult",
          _0: undefined
        });
    Curry._1(dispatch, {
          TAG: "SetSimulationSelection",
          _0: "NoSelection"
        });
    Curry._1(dispatch, {
          TAG: "SetSimulationHistory",
          _0: /* [] */0
        });
    Curry._1(dispatch, {
          TAG: "SetFormSnapshot",
          _0: ImportEnrichmentRuleTypes$ReactHooksTemplate.makeSnapshot(empty.name, empty.priority, true, true, "All", /* [] */0, actions)
        });
    Curry._1(dispatch, {
          TAG: "SetFormOpen",
          _0: true
        });
    ImportEnrichmentRuleHelpers$ReactHooksTemplate.fetchFieldOptions(dispatch, campaignId);
  };
  var openEdit = function (rule) {
    var match = ImportEnrichmentRuleCodec$ReactHooksTemplate.parseDefinitionForForm(rule.definition);
    var actions = match[2];
    var conditions = match[1];
    var mode = match[0];
    var match$1 = ImportEnrichmentRuleTypes$ReactHooksTemplate.pipelinesFromAppliesTo(rule.appliesTo);
    var trigger = match$1[1];
    var feed = match$1[0];
    Curry._1(dispatch, {
          TAG: "SetSelected",
          _0: rule
        });
    Curry._1(dispatch, {
          TAG: "SetConditionMode",
          _0: mode
        });
    Curry._1(dispatch, {
          TAG: "SetConditions",
          _0: conditions
        });
    Curry._1(dispatch, {
          TAG: "SetActions",
          _0: actions
        });
    Curry._1(dispatch, {
          TAG: "SetPipelineFeed",
          _0: feed
        });
    Curry._1(dispatch, {
          TAG: "SetPipelineTrigger",
          _0: trigger
        });
    Curry._1(dispatch, {
          TAG: "SetSimulationResult",
          _0: undefined
        });
    Curry._1(dispatch, {
          TAG: "SetSimulationSelection",
          _0: "NoSelection"
        });
    Curry._1(dispatch, {
          TAG: "SetSimulationHistory",
          _0: /* [] */0
        });
    Curry._1(dispatch, {
          TAG: "SetFormSnapshot",
          _0: ImportEnrichmentRuleTypes$ReactHooksTemplate.makeSnapshot(rule.name, rule.priority, feed, trigger, mode, conditions, actions)
        });
    Curry._1(dispatch, {
          TAG: "SetFormOpen",
          _0: true
        });
    ImportEnrichmentRuleHelpers$ReactHooksTemplate.fetchFieldOptions(dispatch, campaignId);
  };
  var attemptCloseDrawer = function (param) {
    if (state.saving) {
      return ;
    } else if (ImportEnrichmentRuleValidation$ReactHooksTemplate.isFormDirty(state)) {
      return Curry._1(setPendingConfirm, (function (param) {
                    return "DiscardChanges";
                  }));
    } else {
      return Curry._1(dispatch, {
                  TAG: "SetFormOpen",
                  _0: false
                });
    }
  };
  React.useEffect((function (param) {
          if (!state.formOpen) {
            return ;
          }
          var listener = function ($$event) {
            if (ImportEnrichmentRuleHelpers$ReactHooksTemplate.eventKey($$event) !== "Escape") {
              return ;
            }
            var match = pendingConfirmRef.current;
            if (match !== undefined) {
              return Curry._1(setPendingConfirm, (function (param) {
                            
                          }));
            }
            var currentState = stateRef.current;
            if (currentState.saving) {
              return ;
            } else if (ImportEnrichmentRuleValidation$ReactHooksTemplate.isFormDirty(currentState)) {
              return Curry._1(setPendingConfirm, (function (param) {
                            return "DiscardChanges";
                          }));
            } else {
              return Curry._1(dispatch, {
                          TAG: "SetFormOpen",
                          _0: false
                        });
            }
          };
          window.addEventListener("keydown", listener);
          return (function (param) {
                    window.removeEventListener("keydown", listener);
                  });
        }), [state.formOpen]);
  var setPipelines = function (feed, trigger) {
    Curry._1(dispatch, {
          TAG: "SetPipelineFeed",
          _0: feed
        });
    Curry._1(dispatch, {
          TAG: "SetPipelineTrigger",
          _0: trigger
        });
    var init = state.selected;
    Curry._1(dispatch, {
          TAG: "SetSelected",
          _0: {
            id: init.id,
            name: init.name,
            enabled: init.enabled,
            priority: init.priority,
            appliesTo: ImportEnrichmentRuleTypes$ReactHooksTemplate.applyScopeSelection(feed, trigger),
            definition: init.definition
          }
        });
  };
  var confirmPendingAction = function (param) {
    if (pendingConfirm === undefined) {
      return ;
    }
    if (typeof pendingConfirm === "object") {
      Curry._1(setConfirming, (function (param) {
              return true;
            }));
      var id = pendingConfirm.VAL.id;
      if (id !== undefined) {
        Js_promise.$$catch((function (param) {
                Curry._1(dispatch, {
                      TAG: "SetNotification",
                      _0: {
                        TAG: "Failure",
                        _0: "Unable to delete this rule."
                      }
                    });
                Curry._1(setConfirming, (function (param) {
                        return false;
                      }));
                return Promise.resolve();
              }), Js_promise.then_((function (param) {
                    Curry._1(dispatch, {
                          TAG: "SetNotification",
                          _0: {
                            TAG: "Success",
                            _0: "Rule deleted."
                          }
                        });
                    ImportEnrichmentRuleHelpers$ReactHooksTemplate.fetchRules(dispatch, campaignId);
                    Curry._1(setPendingConfirm, (function (param) {
                            
                          }));
                    Curry._1(setConfirming, (function (param) {
                            return false;
                          }));
                    return Promise.resolve();
                  }), Http$ReactHooksTemplate.fetchPostJSON(ImportEnrichmentRuleHelpers$ReactHooksTemplate.basePath(campaignId) + "/" + String(id) + "/destroy", {})));
        return ;
      } else {
        Curry._1(setConfirming, (function (param) {
                return false;
              }));
        return Curry._1(setPendingConfirm, (function (param) {
                      
                    }));
      }
    }
    Curry._1(setConfirming, (function (param) {
            return true;
          }));
    Curry._1(dispatch, {
          TAG: "SetFormOpen",
          _0: false
        });
    Curry._1(setPendingConfirm, (function (param) {
            
          }));
    Curry._1(setConfirming, (function (param) {
            return false;
          }));
  };
  var reorderRules = function (sourceIndex, targetIndex) {
    var rule = Belt_List.get(state.rules, sourceIndex);
    if (rule === undefined) {
      return ;
    }
    var withoutDragged = Belt_List.keepWithIndex(state.rules, (function (param, index) {
            return index !== sourceIndex;
          }));
    var match = Belt_List.splitAt(withoutDragged, targetIndex);
    if (match === undefined) {
      return ;
    }
    var reorderedRules = Belt_List.concat(Belt_List.concat(match[0], {
              hd: rule,
              tl: /* [] */0
            }), match[1]);
    var rulesWithPriority = Belt_List.mapWithIndex(reorderedRules, (function (index, item) {
            return {
                    id: item.id,
                    name: item.name,
                    enabled: item.enabled,
                    priority: index + 1 | 0,
                    appliesTo: item.appliesTo,
                    definition: item.definition
                  };
          }));
    Curry._1(dispatch, {
          TAG: "SetRules",
          _0: rulesWithPriority
        });
    var payload = Json_encode.object_({
          hd: [
            "import_enrichment_rules",
            Belt_List.toArray(Belt_List.keepMap(rulesWithPriority, (function (rule) {
                        return Belt_Option.map(rule.id, (function (id) {
                                      return Json_encode.object_({
                                                  hd: [
                                                    "id",
                                                    id
                                                  ],
                                                  tl: {
                                                    hd: [
                                                      "priority",
                                                      rule.priority
                                                    ],
                                                    tl: /* [] */0
                                                  }
                                                });
                                    }));
                      })))
          ],
          tl: /* [] */0
        });
    Js_promise.$$catch((function (param) {
            Curry._1(dispatch, {
                  TAG: "SetNotification",
                  _0: {
                    TAG: "Failure",
                    _0: "Network error while reordering rules."
                  }
                });
            ImportEnrichmentRuleHelpers$ReactHooksTemplate.fetchRules(dispatch, campaignId);
            return Promise.resolve();
          }), Js_promise.then_((function (json) {
                var response = ImportEnrichmentRuleCodec$ReactHooksTemplate.decodeObject(json);
                var match = ImportEnrichmentRuleCodec$ReactHooksTemplate.getString(response, "status", "error");
                if (match === "success") {
                  ImportEnrichmentRuleHelpers$ReactHooksTemplate.fetchRules(dispatch, campaignId);
                } else {
                  Curry._1(dispatch, {
                        TAG: "SetNotification",
                        _0: {
                          TAG: "Failure",
                          _0: "Unable to update rule order."
                        }
                      });
                  ImportEnrichmentRuleHelpers$ReactHooksTemplate.fetchRules(dispatch, campaignId);
                }
                return Promise.resolve();
              }), Http$ReactHooksTemplate.fetchPostEncodedJSON(ImportEnrichmentRuleHelpers$ReactHooksTemplate.basePath(campaignId) + "/bulk_update", payload)));
  };
  var match$4 = DragDrop$ReactHooksTemplate.useDragDrop(reorderRules);
  var getBlurClass = match$4[3];
  var handleDragDrop = match$4[2];
  var handleDragOver = match$4[1];
  var handleDragStart = match$4[0];
  var id = state.simulationSelection;
  var highlightedSimulationNodeId;
  highlightedSimulationNodeId = typeof id !== "object" ? undefined : id._0;
  var updateConditionAt = function (index, updater) {
    Curry._1(dispatch, {
          TAG: "SetConditions",
          _0: Belt_List.mapWithIndex(state.conditions, (function (i, row) {
                  if (i === index) {
                    return Curry._1(updater, row);
                  } else {
                    return row;
                  }
                }))
        });
  };
  var renderPathPicker = function (value, onChange, includeContextOpt, placeholderOpt, param) {
    var includeContext = includeContextOpt !== undefined ? includeContextOpt : true;
    var placeholder = placeholderOpt !== undefined ? placeholderOpt : "Choose a field";
    var options = state.fieldOptions;
    var pickerOptions = includeContext ? ImportEnrichmentFieldOptions$ReactHooksTemplate.flatReadableOptions(options) : ImportEnrichmentFieldOptions$ReactHooksTemplate.flatWritableOptions(options);
    var knownPaths = Belt_Array.map(pickerOptions, (function (field) {
            return field.path;
          }));
    var selectValue = Belt_Array.some(knownPaths, (function (p) {
            return p === value;
          })) ? value : "";
    return JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsxs("select", {
                        children: [
                          JsxRuntime.jsx("option", {
                                children: placeholder,
                                value: ""
                              }),
                          Belt_Array.map(pickerOptions, (function (field) {
                                  return JsxRuntime.jsx("option", {
                                              children: field.label,
                                              value: field.path
                                            }, field.path);
                                }))
                        ],
                        className: selectBase,
                        disabled: pickerOptions.length === 0,
                        value: selectValue,
                        onChange: (function (e) {
                            Curry._1(onChange, e.target.value);
                          })
                      }),
                  pickerOptions.length === 0 ? JsxRuntime.jsx("p", {
                          children: "Add customer_details Data Fields under General Settings to populate this list.",
                          className: "text-xs text-gray-500 mt-1"
                        }) : null
                ]
              });
  };
  var visibleRules = Belt_List.keep(state.rules, (function (rule) {
          return ImportEnrichmentRuleHelpers$ReactHooksTemplate.filterRule(rule, state);
        }));
  var totalRuleCount = Belt_List.length(state.rules);
  var visibleRuleCount = Belt_List.length(visibleRules);
  var ruleCountLabel = visibleRuleCount === totalRuleCount ? String(totalRuleCount) + " " + (
      totalRuleCount === 1 ? "rule" : "rules"
    ) : String(visibleRuleCount) + " of " + String(totalRuleCount) + " rules";
  var isFeedImportChecked = state.pipelineFeed;
  var isSurveyTriggerChecked = state.pipelineTrigger;
  var noPipelineSelected = !state.pipelineFeed && !state.pipelineTrigger;
  var canReorder = state.searchTerm.trim() === "" && state.statusFilter === "AllStatuses" && state.scopeFilter === "AllPipelines";
  var formIsValid = ImportEnrichmentRuleValidation$ReactHooksTemplate.isFormValid(state.selected.name, state.pipelineFeed, state.pipelineTrigger, state.conditions, state.actions, state.fieldOptions);
  var formStepButton = function (active, label, sectionId, accentClass) {
    return JsxRuntime.jsx("button", {
                children: label,
                "aria-current": active ? "step" : undefined,
                className: "inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-semibold transition-colors duration-200 " + (
                  active ? accentClass : "bg-white text-gray-600 border border-gray-200 hover:border-gray-300 hover:text-gray-800"
                ),
                type: "button",
                onClick: (function (param) {
                    Curry._1(setActiveFormStep, (function (param) {
                            return ImportEnrichmentRuleTypes$ReactHooksTemplate.formStepFromSectionId(sectionId);
                          }));
                    scrollSpyPausedRef.current = true;
                    (((id => { const el = document.getElementById(id); if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' }); }))(sectionId));
                    setTimeout((function (param) {
                            scrollSpyPausedRef.current = false;
                          }), 700);
                  })
              });
  };
  var pipelineCard = function (selected, title, description, onClick) {
    return JsxRuntime.jsx("button", {
                children: JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("span", {
                              children: selected ? JsxRuntime.jsx("span", {
                                      children: "✓",
                                      className: "text-white text-xs leading-none"
                                    }) : null,
                              className: "mt-0.5 flex-shrink-0 w-5 h-5 rounded-full border-2 flex items-center justify-center " + (
                                selected ? "border-verdigris bg-verdigris" : "border-gray-300 bg-white"
                              )
                            }),
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("p", {
                                      children: title,
                                      className: "text-sm font-semibold " + (
                                        selected ? "text-charcoal" : "text-gray-800"
                                      )
                                    }),
                                JsxRuntime.jsx("p", {
                                      children: description,
                                      className: "text-xs text-gray-500 mt-0.5 leading-relaxed"
                                    })
                              ]
                            })
                      ],
                      className: "flex items-start gap-3"
                    }),
                className: "flex-1 min-w-0 text-left p-4 rounded-xl border-2 transition-all duration-200 " + (
                  selected ? "border-verdigris bg-aliceblue shadow-sm" : "border-gray-200 bg-white hover:border-gray-300 hover:bg-gray-50"
                ),
                type: "button",
                onClick: (function (param) {
                    Curry._1(onClick, undefined);
                  })
              });
  };
  var alertType = state.notification;
  var match$5 = state.statusFilter;
  var tmp;
  switch (match$5) {
    case "AllStatuses" :
        tmp = "all";
        break;
    case "EnabledOnly" :
        tmp = "enabled";
        break;
    case "DisabledOnly" :
        tmp = "disabled";
        break;
    
  }
  var match$6 = state.scopeFilter;
  var tmp$1;
  switch (match$6) {
    case "AllPipelines" :
        tmp$1 = "all";
        break;
    case "FeedOnly" :
        tmp$1 = "feed";
        break;
    case "TriggerOnly" :
        tmp$1 = "trigger";
        break;
    case "BothOnly" :
        tmp$1 = "both";
        break;
    
  }
  var tmp$2;
  if (state.formOpen) {
    var match$7 = state.conditionMode;
    var tmp$3;
    tmp$3 = match$7 === "All" ? "all" : "any";
    tmp$2 = JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("div", {
                  className: "absolute inset-0 bg-bigstone50",
                  onClick: (function (param) {
                      if (!state.saving) {
                        return attemptCloseDrawer();
                      }
                      
                    })
                }),
            JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsxs("div", {
                                  children: [
                                    JsxRuntime.jsxs("div", {
                                          children: [
                                            JsxRuntime.jsx("p", {
                                                  children: "Rule Builder",
                                                  className: "text-xs font-bold uppercase tracking-wider text-verdigris mb-1"
                                                }),
                                            JsxRuntime.jsx("h3", {
                                                  children: Belt_Option.isSome(state.selected.id) ? "Edit Import Enrichment Rule" : "Create Import Enrichment Rule",
                                                  className: "text-xl font-bold text-gray-900"
                                                }),
                                            JsxRuntime.jsx("p", {
                                                  children: "Define when a rule runs and what fields to enrich. Simulate with sample data before saving.",
                                                  className: "text-sm text-gray-600 mt-1 max-w-xl"
                                                })
                                          ]
                                        }),
                                    JsxRuntime.jsx("button", {
                                          children: JsxRuntime.jsx("img", {
                                                className: "h-14-px",
                                                alt: "Close",
                                                src: Image$ReactHooksTemplate.closeIcon
                                              }),
                                          "aria-label": "Close",
                                          className: "p-2 rounded-lg hover:bg-white hover:bg-opacity-60 transition-colors disabled:opacity-50 disabled:cursor-not-allowed",
                                          disabled: state.saving,
                                          type: "button",
                                          onClick: (function (param) {
                                              attemptCloseDrawer();
                                            })
                                        })
                                  ],
                                  className: "flex items-start justify-between gap-4"
                                }),
                            JsxRuntime.jsxs("div", {
                                  children: [
                                    formStepButton(activeFormStep === "Basics", "1 · Basics", "ier-section-basics", "bg-verdigris text-white border border-verdigris"),
                                    formStepButton(activeFormStep === "When", "2 · When", "ier-section-when", "bg-cobalt text-white border border-cobalt"),
                                    formStepButton(activeFormStep === "Then", "3 · Then", "ier-section-then", "bg-lochmara text-white border border-lochmara"),
                                    formStepButton(activeFormStep === "Test", "4 · Simulate", "ier-section-test", "bg-iguanagreen text-white border border-iguanagreen")
                                  ],
                                  "aria-label": "Rule builder steps",
                                  className: "mt-4 flex flex-wrap gap-2",
                                  role: "tablist"
                                })
                          ],
                          className: "flex-none shrink-0 bg-gradient-to-r from-aliceblue via-antiflashwhite to-ghostwhiteblue border-b border-gray-200 px-6 py-5"
                        }),
                    JsxRuntime.jsx("div", {
                          children: JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsxs("section", {
                                        children: [
                                          JsxRuntime.jsx("h4", {
                                                children: "Basics",
                                                className: "text-xs font-bold text-verdigris uppercase tracking-wider mb-1"
                                              }),
                                          JsxRuntime.jsx("p", {
                                                children: "Name your rule and choose which import pipelines it applies to.",
                                                className: "text-sm text-gray-600 mb-4"
                                              }),
                                          JsxRuntime.jsxs("div", {
                                                children: [
                                                  JsxRuntime.jsxs("div", {
                                                        children: [
                                                          JsxRuntime.jsxs("label", {
                                                                children: [
                                                                  "Rule name",
                                                                  JsxRuntime.jsx("span", {
                                                                        children: "(required)",
                                                                        className: "text-red-500 font-normal ml-1"
                                                                      })
                                                                ],
                                                                className: labelBase
                                                              }),
                                                          JsxRuntime.jsx("input", {
                                                                className: inputBase,
                                                                placeholder: "e.g. Welcome rule for ABC channel",
                                                                value: state.selected.name,
                                                                onChange: (function (e) {
                                                                    var init = state.selected;
                                                                    Curry._1(dispatch, {
                                                                          TAG: "SetSelected",
                                                                          _0: {
                                                                            id: init.id,
                                                                            name: e.target.value,
                                                                            enabled: init.enabled,
                                                                            priority: init.priority,
                                                                            appliesTo: init.appliesTo,
                                                                            definition: init.definition
                                                                          }
                                                                        });
                                                                  })
                                                              }),
                                                          JsxRuntime.jsx("p", {
                                                                children: "Use a descriptive name — it appears in the rule list and filters.",
                                                                className: hintClass
                                                              })
                                                        ]
                                                      }),
                                                  JsxRuntime.jsxs("div", {
                                                        children: [
                                                          JsxRuntime.jsx("label", {
                                                                children: "Run on pipelines",
                                                                className: labelBase
                                                              }),
                                                          JsxRuntime.jsxs("div", {
                                                                children: [
                                                                  pipelineCard(isFeedImportChecked, "Feed import", "Runs when customer records are imported via feed files.", (function (param) {
                                                                          setPipelines(!isFeedImportChecked, isSurveyTriggerChecked);
                                                                        })),
                                                                  pipelineCard(isSurveyTriggerChecked, "Survey trigger", "Runs when surveys are triggered via the API.", (function (param) {
                                                                          setPipelines(isFeedImportChecked, !isSurveyTriggerChecked);
                                                                        }))
                                                                ],
                                                                className: "flex flex-col sm:flex-row gap-3"
                                                              }),
                                                          noPipelineSelected ? JsxRuntime.jsx("p", {
                                                                  children: "Select at least one pipeline.",
                                                                  className: "text-xs text-firebrick mt-2 font-medium"
                                                                }) : JsxRuntime.jsx("p", {
                                                                  children: isFeedImportChecked && isSurveyTriggerChecked ? "This rule runs on both pipelines." : (
                                                                      isFeedImportChecked ? "This rule runs on feed import only." : "This rule runs on survey trigger only."
                                                                    ),
                                                                  className: hintClass
                                                                })
                                                        ]
                                                      })
                                                ],
                                                className: "space-y-5"
                                              })
                                        ],
                                        className: sectionWrap + " border-verdigris",
                                        id: "ier-section-basics"
                                      }),
                                  JsxRuntime.jsxs("section", {
                                        children: [
                                          JsxRuntime.jsxs("div", {
                                                children: [
                                                  JsxRuntime.jsxs("div", {
                                                        children: [
                                                          JsxRuntime.jsx("h4", {
                                                                children: "When (IF)",
                                                                className: "text-xs font-bold text-cobalt uppercase tracking-wider mb-1"
                                                              }),
                                                          JsxRuntime.jsx("p", {
                                                                children: "Optional filters — leave empty to run on every record.",
                                                                className: "text-sm text-gray-600"
                                                              })
                                                        ]
                                                      }),
                                                  JsxRuntime.jsxs("select", {
                                                        children: [
                                                          JsxRuntime.jsx("option", {
                                                                children: "Match all conditions (AND)",
                                                                value: "all"
                                                              }),
                                                          JsxRuntime.jsx("option", {
                                                                children: "Match any condition (OR)",
                                                                value: "any"
                                                              })
                                                        ],
                                                        className: selectBase + " sm:max-w-xs text-xs font-medium",
                                                        value: tmp$3,
                                                        onChange: (function (e) {
                                                            Curry._1(dispatch, {
                                                                  TAG: "SetConditionMode",
                                                                  _0: e.target.value === "any" ? "Any" : "All"
                                                                });
                                                          })
                                                      })
                                                ],
                                                className: "flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-4"
                                              }),
                                          JsxRuntime.jsxs("div", {
                                                children: [
                                                  JsxRuntime.jsx("div", {
                                                        children: JsxRuntime.jsxs("button", {
                                                              children: [
                                                                JsxRuntime.jsx("span", {
                                                                      children: "+",
                                                                      className: "text-lg leading-none"
                                                                    }),
                                                                "Add condition"
                                                              ],
                                                              className: "inline-flex items-center gap-2 px-4 py-2 text-sm font-semibold text-cobalt bg-white border border-cobalt rounded-lg hover:bg-aliceblue transition-colors duration-200",
                                                              type: "button",
                                                              onClick: (function (param) {
                                                                  Curry._1(dispatch, {
                                                                        TAG: "SetConditions",
                                                                        _0: Belt_List.concatMany([
                                                                              state.conditions,
                                                                              {
                                                                                hd: ImportEnrichmentRuleTypes$ReactHooksTemplate.emptyCondition(),
                                                                                tl: /* [] */0
                                                                              }
                                                                            ])
                                                                      });
                                                                })
                                                            }),
                                                        className: "mb-4"
                                                      }),
                                                  Belt_List.length(state.conditions) === 0 ? JsxRuntime.jsx("div", {
                                                          children: JsxRuntime.jsx("span", {
                                                                children: "No conditions — actions run for all records in selected pipelines."
                                                              }),
                                                          className: "flex flex-col sm:flex-row sm:items-center gap-2 py-3 text-sm text-gray-500"
                                                        }) : null,
                                                  JsxRuntime.jsx("div", {
                                                        children: $$Array.of_list(Belt_List.mapWithIndex(state.conditions, (function (index, row) {
                                                                    var match = ImportEnrichmentSimulationFixture$ReactHooksTemplate.payloadJsonFromInputs(state.simulationInputs);
                                                                    var sample = ImportEnrichmentConditionTest$ReactHooksTemplate.resolveSampleValue(match[0], match[1], row.path);
                                                                    var testResult = ImportEnrichmentConditionTest$ReactHooksTemplate.testCondition(row.op, row.value, row.pattern, row.format, row.caseSensitive, sample);
                                                                    return JsxRuntime.jsxs("div", {
                                                                                children: [
                                                                                  JsxRuntime.jsxs("div", {
                                                                                        children: [
                                                                                          JsxRuntime.jsx("span", {
                                                                                                children: String(index + 1 | 0),
                                                                                                className: "inline-flex items-center justify-center w-7 h-7 rounded-full bg-cobalt text-white text-xs font-bold"
                                                                                              }),
                                                                                          JsxRuntime.jsx("button", {
                                                                                                children: "Remove",
                                                                                                className: "rounded-lg text-xs font-medium border border-red-200 text-firebrick px-3 py-1.5 hover:bg-lavenderblush transition-colors shrink-0",
                                                                                                type: "button",
                                                                                                onClick: (function (param) {
                                                                                                    Curry._1(dispatch, {
                                                                                                          TAG: "SetConditions",
                                                                                                          _0: Belt_List.keepWithIndex(state.conditions, (function (param, i) {
                                                                                                                  return i !== index;
                                                                                                                }))
                                                                                                        });
                                                                                                  })
                                                                                              })
                                                                                        ],
                                                                                        className: "flex items-center justify-between gap-2 mb-3"
                                                                                      }),
                                                                                  JsxRuntime.jsxs("div", {
                                                                                        children: [
                                                                                          JsxRuntime.jsxs("div", {
                                                                                                children: [
                                                                                                  JsxRuntime.jsx("label", {
                                                                                                        children: "Field",
                                                                                                        className: labelBase
                                                                                                      }),
                                                                                                  renderPathPicker(row.path, (function (newPath) {
                                                                                                          updateConditionAt(index, (function (prev) {
                                                                                                                  return ImportEnrichmentCondition$ReactHooksTemplate.normalizeOnPathChange(prev, newPath, state.fieldOptions);
                                                                                                                }));
                                                                                                        }), undefined, "Choose a field to compare", undefined)
                                                                                                ]
                                                                                              }),
                                                                                          JsxRuntime.jsx(ImportEnrichmentConditionForm$ReactHooksTemplate.make, {
                                                                                                row: row,
                                                                                                fieldOptions: state.fieldOptions,
                                                                                                inputBase: inputBase,
                                                                                                selectBase: selectBase,
                                                                                                labelBase: labelBase,
                                                                                                onOperatorChange: (function (newOp) {
                                                                                                    updateConditionAt(index, (function (prev) {
                                                                                                            var kind = ImportEnrichmentCondition$ReactHooksTemplate.fieldKindForPath(prev.path, state.fieldOptions);
                                                                                                            return ImportEnrichmentCondition$ReactHooksTemplate.normalizeOnOperatorChange(prev, newOp, kind, state.fieldOptions);
                                                                                                          }));
                                                                                                  }),
                                                                                                onValueChange: (function (newValue) {
                                                                                                    updateConditionAt(index, (function (prev) {
                                                                                                            return {
                                                                                                                    id: prev.id,
                                                                                                                    path: prev.path,
                                                                                                                    op: prev.op,
                                                                                                                    value: newValue,
                                                                                                                    pattern: prev.pattern,
                                                                                                                    format: prev.format,
                                                                                                                    caseSensitive: prev.caseSensitive,
                                                                                                                    regexMode: prev.regexMode,
                                                                                                                    builderMatchType: prev.builderMatchType,
                                                                                                                    builderText: prev.builderText
                                                                                                                  };
                                                                                                          }));
                                                                                                  }),
                                                                                                onFormatChange: (function (newFormat) {
                                                                                                    updateConditionAt(index, (function (prev) {
                                                                                                            return {
                                                                                                                    id: prev.id,
                                                                                                                    path: prev.path,
                                                                                                                    op: prev.op,
                                                                                                                    value: prev.value,
                                                                                                                    pattern: prev.pattern,
                                                                                                                    format: newFormat,
                                                                                                                    caseSensitive: prev.caseSensitive,
                                                                                                                    regexMode: prev.regexMode,
                                                                                                                    builderMatchType: prev.builderMatchType,
                                                                                                                    builderText: prev.builderText
                                                                                                                  };
                                                                                                          }));
                                                                                                  })
                                                                                              })
                                                                                        ],
                                                                                        className: "space-y-3"
                                                                                      }),
                                                                                  JsxRuntime.jsxs("div", {
                                                                                        children: [
                                                                                          sample !== undefined ? JsxRuntime.jsx("p", {
                                                                                                  children: "Sample value: " + sample,
                                                                                                  className: "text-gray-600 mb-1"
                                                                                                }) : null,
                                                                                          JsxRuntime.jsx("p", {
                                                                                                children: ImportEnrichmentConditionTest$ReactHooksTemplate.testResultLabel(testResult),
                                                                                                className: ImportEnrichmentConditionTest$ReactHooksTemplate.testResultClass(testResult)
                                                                                              })
                                                                                        ],
                                                                                        className: "mt-3 pt-3 border-t border-gray-100 bg-antiflashwhite rounded-lg px-3 py-2 text-xs"
                                                                                      })
                                                                                ],
                                                                                className: cardInner + (
                                                                                  Caml_obj.equal(highlightedSimulationNodeId, row.id) ? " ring-2 ring-blue-500" : ""
                                                                                )
                                                                              }, row.id);
                                                                  }))),
                                                        className: "space-y-3"
                                                      })
                                                ],
                                                className: "bg-gradient-to-r from-gray-50 to-alicebluesolid rounded-xl p-5 border border-gray-200"
                                              })
                                        ],
                                        className: sectionWrap + " border-cobalt",
                                        id: "ier-section-when"
                                      }),
                                  JsxRuntime.jsxs("section", {
                                        children: [
                                          JsxRuntime.jsxs("div", {
                                                children: [
                                                  JsxRuntime.jsxs("div", {
                                                        children: [
                                                          JsxRuntime.jsx("h4", {
                                                                children: "Then (DO)",
                                                                className: "text-xs font-bold text-lochmara uppercase tracking-wider mb-1"
                                                              }),
                                                          JsxRuntime.jsx("p", {
                                                                children: "Choose which field to update and how it should be set when conditions match.",
                                                                className: "text-sm text-gray-600"
                                                              })
                                                        ]
                                                      }),
                                                  JsxRuntime.jsxs("button", {
                                                        children: [
                                                          JsxRuntime.jsx("span", {
                                                                children: "+",
                                                                className: "text-lg leading-none"
                                                              }),
                                                          "Add action"
                                                        ],
                                                        className: "inline-flex items-center gap-2 px-4 py-2 text-sm font-semibold text-lochmara bg-white border border-lochmara rounded-lg hover:bg-antiflashwhite transition-colors duration-200",
                                                        type: "button",
                                                        onClick: (function (param) {
                                                            Curry._1(dispatch, {
                                                                  TAG: "SetActions",
                                                                  _0: Belt_List.concatMany([
                                                                        state.actions,
                                                                        {
                                                                          hd: ImportEnrichmentRuleTypes$ReactHooksTemplate.emptyAction(),
                                                                          tl: /* [] */0
                                                                        }
                                                                      ])
                                                                });
                                                          })
                                                      })
                                                ],
                                                className: "flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-4"
                                              }),
                                          JsxRuntime.jsx("div", {
                                                children: $$Array.of_list(Belt_List.mapWithIndex(state.actions, (function (index, row) {
                                                            return JsxRuntime.jsx(ImportEnrichmentActionForm$ReactHooksTemplate.make, {
                                                                        row: row,
                                                                        index: index,
                                                                        fieldOptions: state.fieldOptions,
                                                                        simulationInputs: state.simulationInputs,
                                                                        canRemove: Belt_List.length(state.actions) > 1,
                                                                        highlighted: Caml_obj.equal(highlightedSimulationNodeId, row.id),
                                                                        onUpdate: (function (updated) {
                                                                            var updater = function (param) {
                                                                              return updated;
                                                                            };
                                                                            Curry._1(dispatch, {
                                                                                  TAG: "SetActions",
                                                                                  _0: Belt_List.mapWithIndex(state.actions, (function (i, row) {
                                                                                          if (i === index) {
                                                                                            return Curry._1(updater, row);
                                                                                          } else {
                                                                                            return row;
                                                                                          }
                                                                                        }))
                                                                                });
                                                                          }),
                                                                        onRemove: (function (param) {
                                                                            Curry._1(dispatch, {
                                                                                  TAG: "SetActions",
                                                                                  _0: Belt_List.length(state.actions) <= 1 ? state.actions : Belt_List.keepWithIndex(state.actions, (function (param, i) {
                                                                                            return i !== index;
                                                                                          }))
                                                                                });
                                                                          })
                                                                      }, row.id);
                                                          }))),
                                                className: "space-y-4"
                                              })
                                        ],
                                        className: sectionWrap + " border-lochmara",
                                        id: "ier-section-then"
                                      }),
                                  JsxRuntime.jsxs("section", {
                                        children: [
                                          JsxRuntime.jsx("h4", {
                                                children: "Simulation Lab",
                                                className: "text-xs font-bold text-iguanagreen uppercase tracking-wider mb-1"
                                              }),
                                          JsxRuntime.jsx("p", {
                                                children: "Dry-run the draft rule in memory — no data is saved. Inspect why conditions pass or fail and what each action would do.",
                                                className: "text-sm text-gray-600 mb-4"
                                              }),
                                          JsxRuntime.jsx("div", {
                                                children: JsxRuntime.jsx(ImportEnrichmentRuleSimulator$ReactHooksTemplate.make, {
                                                      state: state,
                                                      dispatch: dispatch,
                                                      onSimulate: (function (param) {
                                                          var fieldInputs = ImportEnrichmentSimulationInputs$ReactHooksTemplate.buildFieldInputs(state.conditions, state.actions, state.fieldOptions);
                                                          if (Belt_List.length(fieldInputs) === 0) {
                                                            return Curry._1(dispatch, {
                                                                        TAG: "SetNotification",
                                                                        _0: {
                                                                          TAG: "Failure",
                                                                          _0: "Add a condition or action that reads a field before simulating."
                                                                        }
                                                                      });
                                                          }
                                                          Curry._1(dispatch, {
                                                                TAG: "SetSimulating",
                                                                _0: true
                                                              });
                                                          var match = ImportEnrichmentSimulationFixture$ReactHooksTemplate.payloadJsonFromInputs(state.simulationInputs);
                                                          var params = {};
                                                          var pipeline = ImportEnrichmentRule$ReactHooksTemplate.appliesToToString(ImportEnrichmentRuleTypes$ReactHooksTemplate.applyScopeSelection(state.pipelineFeed, state.pipelineTrigger));
                                                          params["pipeline"] = pipeline === "both" ? "feed_import" : pipeline;
                                                          var fixture = {};
                                                          fixture["payload"] = match[0];
                                                          fixture["context"] = match[1];
                                                          params["fixture"] = fixture;
                                                          params["definition"] = ImportEnrichmentRuleCodec$ReactHooksTemplate.buildDefinitionJson(state.conditionMode, state.conditions, state.actions);
                                                          var options = {};
                                                          options["short_circuit"] = true;
                                                          options["include_variable_snapshots"] = true;
                                                          params["options"] = options;
                                                          Js_promise.$$catch((function (param) {
                                                                  Curry._1(dispatch, {
                                                                        TAG: "SetSimulating",
                                                                        _0: false
                                                                      });
                                                                  Curry._1(dispatch, {
                                                                        TAG: "SetNotification",
                                                                        _0: {
                                                                          TAG: "Failure",
                                                                          _0: "Simulation failed. Please try again."
                                                                        }
                                                                      });
                                                                  return Promise.resolve();
                                                                }), Js_promise.then_((function (json) {
                                                                      var response = ImportEnrichmentRuleCodec$ReactHooksTemplate.decodeObject(json);
                                                                      var simulation = Belt_Option.getWithDefault(Belt_Option.flatMap(Belt_Option.flatMap(Js_dict.get(response, "data"), Js_json.decodeObject), (function (data) {
                                                                                  return Js_dict.get(data, "simulation");
                                                                                })), {});
                                                                      var simulationObj = ImportEnrichmentRuleCodec$ReactHooksTemplate.decodeObject(simulation);
                                                                      var ruleMatched = Belt_Option.getWithDefault(Belt_Option.flatMap(Belt_Option.flatMap(Js_dict.get(simulationObj, "verdict"), Js_json.decodeObject), (function (v) {
                                                                                  return Belt_Option.flatMap(Js_dict.get(v, "rule_matched"), Js_json.decodeBoolean);
                                                                                })), Belt_Option.getWithDefault(Belt_Option.flatMap(Js_dict.get(simulationObj, "rule_matched"), Js_json.decodeBoolean), false));
                                                                      Curry._1(dispatch, {
                                                                            TAG: "SetSimulationResult",
                                                                            _0: simulation
                                                                          });
                                                                      Curry._1(dispatch, {
                                                                            TAG: "SetSimulationSelection",
                                                                            _0: "NoSelection"
                                                                          });
                                                                      Curry._1(dispatch, {
                                                                            TAG: "PushSimulationHistory",
                                                                            _0: {
                                                                              id: "run_" + Date.now().toString(),
                                                                              ranAt: Date.now(),
                                                                              inputs: ImportEnrichmentSimulationFixture$ReactHooksTemplate.cloneInputs(state.simulationInputs),
                                                                              resultJson: simulation,
                                                                              ruleMatched: ruleMatched
                                                                            }
                                                                          });
                                                                      Curry._1(dispatch, {
                                                                            TAG: "SetSimulating",
                                                                            _0: false
                                                                          });
                                                                      return Promise.resolve();
                                                                    }), Http$ReactHooksTemplate.fetchPostJSON(ImportEnrichmentRuleHelpers$ReactHooksTemplate.basePath(campaignId) + "/simulate", params)));
                                                        }),
                                                      highlightedNodeId: highlightedSimulationNodeId,
                                                      conditions: state.conditions,
                                                      actions: state.actions
                                                    }),
                                                className: "bg-gradient-to-r from-gray-50 to-ngreen_100 rounded-xl p-5 border border-gray-200"
                                              })
                                        ],
                                        className: sectionWrap + " border-iguanagreen",
                                        id: "ier-section-test"
                                      })
                                ],
                                className: "px-6 py-6 space-y-8 pb-6"
                              }),
                          className: "flex-1 min-h-0 overflow-y-auto overflow-x-hidden overscroll-contain",
                          id: "ier-form-scroll"
                        }),
                    JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsx("button", {
                                  children: "Cancel",
                                  className: ghostBtn + (
                                    state.saving ? " opacity-50 cursor-not-allowed" : ""
                                  ),
                                  disabled: state.saving,
                                  type: "button",
                                  onClick: (function (param) {
                                      attemptCloseDrawer();
                                    })
                                }),
                            JsxRuntime.jsx("button", {
                                  children: state.saving ? "Saving..." : (
                                      Belt_Option.isSome(state.selected.id) ? "Save changes" : "Create rule"
                                    ),
                                  className: primaryBtn + (
                                    state.saving ? " bg-blue-400 cursor-wait" : (
                                        formIsValid ? " bg-blue-600 hover:bg-blue-700" : " bg-gray-400 cursor-not-allowed"
                                      )
                                  ),
                                  disabled: state.saving || !formIsValid,
                                  type: "button",
                                  onClick: (function (param) {
                                      var message = ImportEnrichmentRuleValidation$ReactHooksTemplate.validateForm(state.selected.name, state.pipelineFeed, state.pipelineTrigger, state.conditions, state.actions, state.fieldOptions);
                                      if (message !== undefined) {
                                        return Curry._1(dispatch, {
                                                    TAG: "SetNotification",
                                                    _0: {
                                                      TAG: "Failure",
                                                      _0: message
                                                    }
                                                  });
                                      }
                                      Curry._1(dispatch, {
                                            TAG: "SetSaving",
                                            _0: true
                                          });
                                      var params = {};
                                      var definitionJson = ImportEnrichmentRuleCodec$ReactHooksTemplate.buildDefinitionJson(state.conditionMode, state.conditions, state.actions);
                                      var appliesTo = ImportEnrichmentRuleTypes$ReactHooksTemplate.applyScopeSelection(state.pipelineFeed, state.pipelineTrigger);
                                      var init = state.selected;
                                      var payload = ImportEnrichmentRule$ReactHooksTemplate.encode({
                                            id: init.id,
                                            name: init.name,
                                            enabled: init.enabled,
                                            priority: init.priority,
                                            appliesTo: appliesTo,
                                            definition: definitionJson
                                          });
                                      params["import_enrichment_rule"] = payload;
                                      var base = ImportEnrichmentRuleHelpers$ReactHooksTemplate.basePath(campaignId);
                                      var id = state.selected.id;
                                      var request = id !== undefined ? Http$ReactHooksTemplate.fetchPostJSON(base + "/" + String(id) + "/update", params) : Http$ReactHooksTemplate.fetchPostJSON(base, params);
                                      Js_promise.$$catch((function (param) {
                                              Curry._1(dispatch, {
                                                    TAG: "SetSaving",
                                                    _0: false
                                                  });
                                              Curry._1(dispatch, {
                                                    TAG: "SetNotification",
                                                    _0: {
                                                      TAG: "Failure",
                                                      _0: "Network error while saving the rule."
                                                    }
                                                  });
                                              return Promise.resolve();
                                            }), Js_promise.then_((function (json) {
                                                  var response = ImportEnrichmentRuleCodec$ReactHooksTemplate.decodeObject(json);
                                                  var status = ImportEnrichmentRuleCodec$ReactHooksTemplate.getString(response, "status", "error");
                                                  switch (status) {
                                                    case "failure" :
                                                        var message = Belt_Option.getWithDefault(Belt_Option.map(Belt_Option.flatMap(Js_dict.get(response, "errors"), Js_json.decodeArray), (function (arr) {
                                                                    return Belt_Array.keepMap(arr, Js_json.decodeString).join(", ");
                                                                  })), "Failed to save rule.");
                                                        Curry._1(dispatch, {
                                                              TAG: "SetNotification",
                                                              _0: {
                                                                TAG: "Failure",
                                                                _0: message
                                                              }
                                                            });
                                                        break;
                                                    case "success" :
                                                        Curry._1(dispatch, {
                                                              TAG: "SetNotification",
                                                              _0: {
                                                                TAG: "Success",
                                                                _0: "Rule saved successfully."
                                                              }
                                                            });
                                                        Curry._1(dispatch, {
                                                              TAG: "SetFormOpen",
                                                              _0: false
                                                            });
                                                        ImportEnrichmentRuleHelpers$ReactHooksTemplate.fetchRules(dispatch, campaignId);
                                                        break;
                                                    default:
                                                      Curry._1(dispatch, {
                                                            TAG: "SetNotification",
                                                            _0: {
                                                              TAG: "Failure",
                                                              _0: "Something went wrong while saving the rule."
                                                            }
                                                          });
                                                  }
                                                  Curry._1(dispatch, {
                                                        TAG: "SetSaving",
                                                        _0: false
                                                      });
                                                  return Promise.resolve();
                                                }), request));
                                    })
                                })
                          ],
                          className: "flex-none shrink-0 flex justify-end gap-3 p-6 border-t border-gray-200 bg-white"
                        })
                  ],
                  "aria-label": Belt_Option.isSome(state.selected.id) ? "Edit Import Enrichment Rule" : "Create Import Enrichment Rule",
                  "aria-modal": true,
                  className: "absolute right-0 top-0 h-full w-full max-w-4xl bg-ghostwhitegray shadow-2xl flex flex-col",
                  role: "dialog"
                })
          ],
          className: "fixed inset-0 z-50"
        });
  } else {
    tmp$2 = null;
  }
  return JsxRuntime.jsxs("div", {
              children: [
                alertType !== undefined ? JsxRuntime.jsx("div", {
                        children: JsxRuntime.jsx(AlertComponent$ReactHooksTemplate.make, {
                              alertType: alertType,
                              handleClose: (function (param) {
                                  Curry._1(dispatch, {
                                        TAG: "SetNotification",
                                        _0: undefined
                                      });
                                })
                            }),
                        className: "max-w-7xl mx-auto px-6 sm:px-8 py-4"
                      }) : null,
                JsxRuntime.jsxs("div", {
                      children: [
                        campaignId !== undefined ? JsxRuntime.jsx("div", {
                                children: JsxRuntime.jsx("p", {
                                      children: "These rules apply only to this campaign. When organization Import Enrichment is enabled, tenant-wide rules from General Settings run first, then this campaign's rules."
                                    }),
                                className: "mb-4 rounded-xl border border-blue-200 bg-aliceblue px-4 py-3 text-sm text-gray-700"
                              }) : null,
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsxs("div", {
                                                    children: [
                                                      JsxRuntime.jsxs("div", {
                                                            children: [
                                                              JsxRuntime.jsx("h1", {
                                                                    children: campaignId !== undefined ? "Campaign Import Enrichment Rules" : "Import Enrichment Rules",
                                                                    className: "text-2xl font-bold text-gray-900"
                                                                  }),
                                                              state.loading ? null : JsxRuntime.jsx("span", {
                                                                      children: ruleCountLabel,
                                                                      className: "inline-flex items-center px-2.5 py-0.5 text-xs font-medium text-verdigris bg-white border border-verdigris rounded-full"
                                                                    })
                                                            ],
                                                            className: "flex items-center gap-2 flex-wrap"
                                                          }),
                                                      JsxRuntime.jsx("p", {
                                                            children: "Build IF/THEN rules to enrich imported records. Use Simulation Lab to test safely before enabling.",
                                                            className: "text-sm text-gray-600 mt-1"
                                                          })
                                                    ]
                                                  }),
                                              JsxRuntime.jsxs("button", {
                                                    children: [
                                                      JsxRuntime.jsx("span", {
                                                            children: "+"
                                                          }),
                                                      JsxRuntime.jsx("span", {
                                                            children: "Create Rule"
                                                          })
                                                    ],
                                                    className: "inline-flex items-center gap-2 px-4 py-2 bg-verdigris text-white rounded-lg hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-verdigris transition-colors",
                                                    onClick: (function (param) {
                                                        openCreate();
                                                      })
                                                  })
                                            ],
                                            className: "flex flex-col md:flex-row md:items-center md:justify-between gap-4"
                                          }),
                                      className: "bg-gradient-to-r from-aliceblue via-antiflashwhite to-ghostwhiteblue px-6 py-5 border-b border-gray-200"
                                    }),
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsxs("div", {
                                              children: [
                                                JsxRuntime.jsxs("div", {
                                                      children: [
                                                        JsxRuntime.jsx("label", {
                                                              children: "Search",
                                                              className: "block text-xs font-medium text-gray-600 mb-1"
                                                            }),
                                                        JsxRuntime.jsx("input", {
                                                              className: inputBase,
                                                              placeholder: "Search by name or rule summary",
                                                              value: state.searchTerm,
                                                              onChange: (function (e) {
                                                                  Curry._1(dispatch, {
                                                                        TAG: "SetSearchTerm",
                                                                        _0: e.target.value
                                                                      });
                                                                })
                                                            })
                                                      ]
                                                    }),
                                                JsxRuntime.jsxs("div", {
                                                      children: [
                                                        JsxRuntime.jsx("label", {
                                                              children: "Status",
                                                              className: "block text-xs font-medium text-gray-600 mb-1"
                                                            }),
                                                        JsxRuntime.jsxs("select", {
                                                              children: [
                                                                JsxRuntime.jsx("option", {
                                                                      children: "All statuses",
                                                                      value: "all"
                                                                    }),
                                                                JsxRuntime.jsx("option", {
                                                                      children: "Enabled",
                                                                      value: "enabled"
                                                                    }),
                                                                JsxRuntime.jsx("option", {
                                                                      children: "Disabled",
                                                                      value: "disabled"
                                                                    })
                                                              ],
                                                              className: selectBase,
                                                              value: tmp,
                                                              onChange: (function (e) {
                                                                  var match = e.target.value;
                                                                  var tmp;
                                                                  switch (match) {
                                                                    case "disabled" :
                                                                        tmp = "DisabledOnly";
                                                                        break;
                                                                    case "enabled" :
                                                                        tmp = "EnabledOnly";
                                                                        break;
                                                                    default:
                                                                      tmp = "AllStatuses";
                                                                  }
                                                                  Curry._1(dispatch, {
                                                                        TAG: "SetStatusFilter",
                                                                        _0: tmp
                                                                      });
                                                                })
                                                            })
                                                      ]
                                                    }),
                                                JsxRuntime.jsxs("div", {
                                                      children: [
                                                        JsxRuntime.jsx("label", {
                                                              children: "Pipeline",
                                                              className: "block text-xs font-medium text-gray-600 mb-1"
                                                            }),
                                                        JsxRuntime.jsxs("select", {
                                                              children: [
                                                                JsxRuntime.jsx("option", {
                                                                      children: "All pipelines",
                                                                      value: "all"
                                                                    }),
                                                                JsxRuntime.jsx("option", {
                                                                      children: "Feed import",
                                                                      value: "feed"
                                                                    }),
                                                                JsxRuntime.jsx("option", {
                                                                      children: "Survey trigger",
                                                                      value: "trigger"
                                                                    }),
                                                                JsxRuntime.jsx("option", {
                                                                      children: "Both pipelines",
                                                                      value: "both"
                                                                    })
                                                              ],
                                                              className: selectBase,
                                                              value: tmp$1,
                                                              onChange: (function (e) {
                                                                  var match = e.target.value;
                                                                  var tmp;
                                                                  switch (match) {
                                                                    case "both" :
                                                                        tmp = "BothOnly";
                                                                        break;
                                                                    case "feed" :
                                                                        tmp = "FeedOnly";
                                                                        break;
                                                                    case "trigger" :
                                                                        tmp = "TriggerOnly";
                                                                        break;
                                                                    default:
                                                                      tmp = "AllPipelines";
                                                                  }
                                                                  Curry._1(dispatch, {
                                                                        TAG: "SetScopeFilter",
                                                                        _0: tmp
                                                                      });
                                                                })
                                                            })
                                                      ]
                                                    })
                                              ],
                                              className: "grid grid-cols-1 md:grid-cols-3 gap-3"
                                            }),
                                        !state.loading && visibleRuleCount > 0 ? JsxRuntime.jsx("p", {
                                                children: canReorder ? "Drag rules to reorder. Top rule runs first (priority 1 = highest)." : "Clear search and filters to drag rules and change their priority.",
                                                className: "text-xs text-gray-500 mt-3"
                                              }) : null
                                      ],
                                      className: "px-6 py-4 bg-gray-50 border-b border-gray-200"
                                    }),
                                state.loading ? JsxRuntime.jsx("div", {
                                        children: "Loading import enrichment rules...",
                                        className: "p-8 text-sm text-gray-600"
                                      }) : (
                                    visibleRuleCount === 0 ? JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx("div", {
                                                    children: "🧬",
                                                    className: "text-3xl mb-2"
                                                  }),
                                              JsxRuntime.jsx("h3", {
                                                    children: "No rules found",
                                                    className: "text-base font-semibold text-gray-900"
                                                  }),
                                              JsxRuntime.jsx("p", {
                                                    children: "Create your first rule or adjust search and filters.",
                                                    className: "text-sm text-gray-600 mt-1"
                                                  }),
                                              JsxRuntime.jsxs("button", {
                                                    children: [
                                                      JsxRuntime.jsx("span", {
                                                            children: "+"
                                                          }),
                                                      JsxRuntime.jsx("span", {
                                                            children: "Create Rule"
                                                          })
                                                    ],
                                                    className: "inline-flex items-center gap-2 mt-4 px-4 py-2 bg-verdigris text-white rounded-lg hover:opacity-90",
                                                    onClick: (function (param) {
                                                        openCreate();
                                                      })
                                                  })
                                            ],
                                            className: "p-10 text-center"
                                          }) : JsxRuntime.jsx("div", {
                                            children: $$Array.of_list(Belt_List.mapWithIndex(visibleRules, (function (index, rule) {
                                                        return JsxRuntime.jsxs("div", {
                                                                    children: [
                                                                      JsxRuntime.jsxs("div", {
                                                                            children: [
                                                                              JsxRuntime.jsxs("div", {
                                                                                    children: [
                                                                                      canReorder ? JsxRuntime.jsxs("span", {
                                                                                              children: [
                                                                                                JsxRuntime.jsx("span", {
                                                                                                      children: "⋮⋮",
                                                                                                      className: "block text-lg leading-none"
                                                                                                    }),
                                                                                                JsxRuntime.jsx("span", {
                                                                                                      children: String(rule.priority),
                                                                                                      className: "block text-xs font-semibold text-gray-600 text-center mt-0.5"
                                                                                                    })
                                                                                              ],
                                                                                              className: "flex-shrink-0 text-gray-400 mt-1 select-none",
                                                                                              title: "Drag to reorder",
                                                                                              onClick: (function (e) {
                                                                                                  e.stopPropagation();
                                                                                                })
                                                                                            }) : JsxRuntime.jsx("span", {
                                                                                              children: String(rule.priority),
                                                                                              className: "flex-shrink-0 w-8 text-center text-xs font-semibold text-gray-500 mt-1"
                                                                                            }),
                                                                                      JsxRuntime.jsxs("div", {
                                                                                            children: [
                                                                                              JsxRuntime.jsxs("div", {
                                                                                                    children: [
                                                                                                      JsxRuntime.jsx("h3", {
                                                                                                            children: rule.name,
                                                                                                            className: "font-semibold text-gray-900"
                                                                                                          }),
                                                                                                      JsxRuntime.jsx("span", {
                                                                                                            children: ImportEnrichmentRule$ReactHooksTemplate.appliesToLabel(rule.appliesTo),
                                                                                                            className: "px-2 py-0.5 text-xs rounded-full bg-aliceblue text-verdigris border border-verdigris border-opacity-30"
                                                                                                          }),
                                                                                                      rule.enabled ? null : JsxRuntime.jsx("span", {
                                                                                                              children: "Disabled",
                                                                                                              className: "px-2 py-0.5 text-xs rounded-full bg-gray-100 text-gray-600"
                                                                                                            })
                                                                                                    ],
                                                                                                    className: "flex items-center gap-2 flex-wrap"
                                                                                                  }),
                                                                                              JsxRuntime.jsx("p", {
                                                                                                    children: ImportEnrichmentRuleHelpers$ReactHooksTemplate.ruleSummary(rule),
                                                                                                    className: "text-sm text-gray-600 mt-1 leading-relaxed"
                                                                                                  })
                                                                                            ],
                                                                                            className: "flex-1 min-w-0"
                                                                                          })
                                                                                    ],
                                                                                    className: "flex items-start gap-3 flex-1 min-w-0"
                                                                                  }),
                                                                              JsxRuntime.jsxs("label", {
                                                                                    children: [
                                                                                      JsxRuntime.jsx(ToggleInput$ReactHooksTemplate.make, {
                                                                                            checked: rule.enabled,
                                                                                            handleChange: (function (param) {
                                                                                                var id = rule.id;
                                                                                                if (id !== undefined) {
                                                                                                  Js_promise.$$catch((function (param) {
                                                                                                          Curry._1(dispatch, {
                                                                                                                TAG: "SetNotification",
                                                                                                                _0: {
                                                                                                                  TAG: "Failure",
                                                                                                                  _0: "Unable to update rule status."
                                                                                                                }
                                                                                                              });
                                                                                                          return Promise.resolve();
                                                                                                        }), Js_promise.then_((function (param) {
                                                                                                              ImportEnrichmentRuleHelpers$ReactHooksTemplate.fetchRules(dispatch, campaignId);
                                                                                                              return Promise.resolve();
                                                                                                            }), Http$ReactHooksTemplate.fetchPostJSON(ImportEnrichmentRuleHelpers$ReactHooksTemplate.basePath(campaignId) + "/" + String(id) + "/toggle", {})));
                                                                                                  return ;
                                                                                                }
                                                                                                
                                                                                              })
                                                                                          }),
                                                                                      JsxRuntime.jsx("span", {
                                                                                            children: rule.enabled ? "Enabled" : "Disabled",
                                                                                            className: "text-xs text-gray-600"
                                                                                          })
                                                                                    ],
                                                                                    className: "inline-flex items-center gap-2 flex-shrink-0",
                                                                                    onClick: (function (e) {
                                                                                        e.stopPropagation();
                                                                                      })
                                                                                  })
                                                                            ],
                                                                            className: "flex items-start justify-between gap-3"
                                                                          }),
                                                                      JsxRuntime.jsxs("div", {
                                                                            children: [
                                                                              JsxRuntime.jsx("button", {
                                                                                    children: "Edit",
                                                                                    className: "px-3 py-1.5 text-sm border border-gray-300 rounded-lg hover:bg-white",
                                                                                    onClick: (function (param) {
                                                                                        openEdit(rule);
                                                                                      })
                                                                                  }),
                                                                              JsxRuntime.jsx("button", {
                                                                                    children: "Delete",
                                                                                    className: "px-3 py-1.5 text-sm border border-red-300 text-red-600 rounded-lg hover:bg-red-50",
                                                                                    onClick: (function (param) {
                                                                                        Curry._1(setPendingConfirm, (function (param) {
                                                                                                return {
                                                                                                        NAME: "DeleteRule",
                                                                                                        VAL: rule
                                                                                                      };
                                                                                              }));
                                                                                      })
                                                                                  })
                                                                            ],
                                                                            className: "mt-3 flex items-center gap-2",
                                                                            onClick: (function (e) {
                                                                                e.stopPropagation();
                                                                              })
                                                                          })
                                                                    ],
                                                                    className: "rounded-xl border border-gray-200 p-4 transition-colors hover:border-verdigris hover:bg-aliceblue " + (
                                                                      canReorder ? "cursor-move " + Curry._1(getBlurClass, index) : "cursor-pointer"
                                                                    ),
                                                                    draggable: canReorder,
                                                                    role: "button",
                                                                    tabIndex: 0,
                                                                    onKeyDown: (function (e) {
                                                                        var match = e.key;
                                                                        switch (match) {
                                                                          case " " :
                                                                          case "Enter" :
                                                                              return openEdit(rule);
                                                                          default:
                                                                            return ;
                                                                        }
                                                                      }),
                                                                    onClick: (function (param) {
                                                                        openEdit(rule);
                                                                      }),
                                                                    onDragOver: (function (e) {
                                                                        if (canReorder) {
                                                                          return Curry._2(handleDragOver, index, e);
                                                                        }
                                                                        
                                                                      }),
                                                                    onDragStart: (function (e) {
                                                                        if (canReorder) {
                                                                          return Curry._2(handleDragStart, index, e);
                                                                        }
                                                                        
                                                                      }),
                                                                    onDrop: (function (e) {
                                                                        if (canReorder) {
                                                                          return Curry._2(handleDragDrop, index, e);
                                                                        }
                                                                        
                                                                      })
                                                                  }, String(Belt_Option.getWithDefault(rule.id, 0)));
                                                      }))),
                                            className: "p-4 space-y-3"
                                          })
                                  )
                              ],
                              className: "bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden"
                            })
                      ],
                      className: "max-w-7xl mx-auto px-6 py-8"
                    }),
                tmp$2,
                pendingConfirm !== undefined ? (
                    typeof pendingConfirm === "object" ? JsxRuntime.jsx(ConfirmDialog$ReactHooksTemplate.make, {
                            title: "Delete rule?",
                            message: "Delete rule \"" + pendingConfirm.VAL.name + "\"? This action cannot be undone.",
                            confirmLabel: "Delete rule",
                            cancelLabel: "Cancel",
                            variant: "Danger",
                            confirming: confirming,
                            onCancel: (function (param) {
                                Curry._1(setPendingConfirm, (function (param) {
                                        
                                      }));
                              }),
                            onConfirm: (function (param) {
                                confirmPendingAction();
                              })
                          }) : JsxRuntime.jsx(ConfirmDialog$ReactHooksTemplate.make, {
                            title: "Discard unsaved changes?",
                            message: "You have unsaved changes. Discard them and close the rule builder?",
                            confirmLabel: "Discard",
                            cancelLabel: "Keep editing",
                            variant: "Warning",
                            confirming: confirming,
                            onCancel: (function (param) {
                                Curry._1(setPendingConfirm, (function (param) {
                                        
                                      }));
                              }),
                            onConfirm: (function (param) {
                                confirmPendingAction();
                              })
                          })
                  ) : null
              ],
              className: "h-full bg-gray-50"
            });
}

var make = ImportEnrichmentRules;

exports.inputBase = inputBase;
exports.selectBase = selectBase;
exports.labelBase = labelBase;
exports.hintClass = hintClass;
exports.sectionWrap = sectionWrap;
exports.cardInner = cardInner;
exports.ghostBtn = ghostBtn;
exports.primaryBtn = primaryBtn;
exports.make = make;
/* react Not a pure module */
